export const guarantees = [
  '7 días de garantía',
  'Pago seguro',
  'Acceso inmediato',
  'Paga en tu moneda local',
]

export const heroQuotes = [
  {
    quote: 'Por primera vez entendí por qué no podía irme aunque quisiera.',
    author: 'M.R.',
    place: 'Argentina',
  },
  {
    quote: 'Pude leer sus mensajes sin desmoronarme. Eso solo ya valió cada centavo.',
    author: 'C.L.',
    place: 'México',
  },
  {
    quote: 'Vi los patrones que yo misma me negaba a ver. Ese fue mi punto de no retorno.',
    author: 'V.S.',
    place: 'España',
  },
]

export const costItems = [
  {
    title: 'Noches sin dormir',
    text: 'Analizando lo que dijo, lo que hizo, lo que podría significar.',
  },
  {
    title: 'Intentos de separación',
    text: 'Que terminan en regreso sin entender por qué.',
  },
  {
    title: 'Culpa constante',
    text: 'Que te hace dudar de tu propia percepción.',
  },
  {
    title: 'Miedo al futuro',
    text: 'Que paraliza cada decisión.',
  },
  {
    title: 'Identidad perdida',
    text: 'Sin saber quién eres fuera de esta relación.',
  },
  {
    title: 'Energía agotada',
    text: 'En el ciclo que no queda para construir lo que quieres.',
  },
]

export const phases = [
  {
    label: 'Fase 1',
    name: 'La claridad',
    text: 'Entender exactamente qué está pasando y por qué no has podido salir hasta ahora.',
  },
  {
    label: 'Fase 2',
    name: 'La salida',
    text: 'El plan emocional, práctico y logístico para moverte cuando estés lista.',
  },
  {
    label: 'Fase 3',
    name: 'La vida nueva',
    text: 'La reconstrucción de tu identidad, tu independencia y la vida que viene después de él.',
  },
]

export const volumes = [
  {
    number: 'Volumen 1',
    title: 'El Mapa de la Realidad',
    text: 'Entiende exactamente qué está pasando. El gaslighting, el ciclo del caos, el vínculo traumático y las formas invisibles de control que te tienen atrapada sin poder nombrarlas.',
  },
  {
    number: 'Volumen 2',
    title: 'El Desapego Emocional',
    text: 'Por qué saber no alcanza para soltar. La química del apego traumático, el duelo real y el protocolo de 30 días para desintoxicarte emocionalmente de alguien a quien todavía amas aunque te haga daño.',
  },
  {
    number: 'Volumen 3',
    title: 'Logística de Libertad',
    text: 'El plan concreto para preparar tu salida sin improvisar. Documentos, dinero, seguridad y el protocolo paso a paso para el día del movimiento.',
  },
  {
    number: 'Volumen 4',
    title: 'El Protocolo Familiar',
    text: 'Cómo proteger a tus hijos del conflicto, cómo hablar con ellos y cómo construir una nueva red de apoyo sólida.',
  },
  {
    number: 'Volumen 5',
    title: 'El Escudo de Comunicación',
    text: 'Cómo comunicarte con él después de la separación sin caer en el ciclo, sin justificarte y sin que sus mensajes sigan desestabilizándote.',
  },
  {
    number: 'Volumen 6',
    title: 'La Nueva Identidad',
    text: 'Quién eres tú fuera de esta relación. Cómo reconstruir tu autoestima, recuperar tu identidad y diseñar la vida que viene después de él.',
  },
]

export const bonuses = [
  {
    number: 'Bono 1',
    title: 'Guía para cortar el ciclo de comunicación',
    text: 'Plantillas y estrategias para responder sin engancharte: límites claros, frases útiles para no entrar en provocaciones y pautas para sostener distancia emocional.',
  },
  {
    number: 'Bono 2',
    title: 'El Diario de Realidad',
    text: '30 días de prompts guiados para recuperar la confianza en tu propia percepción.',
  },
  {
    number: 'Bono 3',
    title: 'El Kit Anti-Recaída Emocional',
    text: 'Protocolos de emergencia para los momentos donde el impulso de volver es más fuerte que la decisión de quedarte.',
  },
  {
    number: 'Bono 4',
    title: 'El Mapa de Calma',
    text: '15 ejercicios rápidos para regular tu sistema nervioso cuando la ansiedad, la culpa o el miedo intentan tomar el control.',
  },
  {
    number: 'Bono 5',
    title: 'El Detox de Él',
    text: 'Protocolo digital, emocional, físico, social y de rutinas para identificar y reducir los disparadores que te devuelven a él: mapa de disparadores, limpieza del teléfono y redes, fotos y recuerdos, espacios, fechas difíciles y un reset de 7 días.',
  },
]

export const offerItems = [
  '6 Volúmenes del método completo',
  '5 Bonos de implementación inmediata',
  'Acceso permanente a todos los archivos',
  'PDF compatible con cualquier dispositivo',
  'Sin reuniones, sin grupos, sin exposición',
  'A tu ritmo, en tu privacidad',
  'Garantía de 7 días',
]

export const testimonials = [
  {
    quote: 'Nadie me lo había explicado así. Por primera vez sentí que no estaba loca.',
    author: 'P.M.',
    place: 'Colombia',
  },
  {
    quote:
      'El Kit Anti-Recaída me salvó tres veces en el primer mes. Hubo noches donde lo único que me detuvo fue seguir el protocolo paso a paso.',
    author: 'A.R.',
    place: 'México',
  },
  {
    quote:
      'Hice el Diario de Realidad completo. Al releerlo entendí que había estado minimizando cosas muy serias. Ese diario fue mi punto de no retorno.',
    author: 'M.C.',
    place: 'España',
  },
  {
    quote:
      'El Detox de Él me dio la estructura que necesitaba cuando no sabía por dónde empezar. Semana a semana fui viendo los cambios.',
    author: 'S.V.',
    place: 'Argentina',
  },
]

export const faqs = [
  {
    question: '¿Cómo recibo el sistema?',
    answer:
      'Acceso inmediato al momento de la compra. Descarga todos los archivos en PDF desde cualquier dispositivo.',
  },
  {
    question: '¿Para qué etapa del proceso es?',
    answer:
      'Para cualquier etapa. Si todavía estás en la relación, si ya decidiste irte o si ya saliste y estás reconstruyendo.',
  },
  {
    question: '¿Funciona si tengo hijos?',
    answer:
      'Sí. El Volumen 4 está dedicado específicamente a la situación con hijos y co-parentalidad.',
  },
  {
    question: '¿Necesito hablar con alguien?',
    answer:
      'No. Es completamente privado y autónomo. Sin reuniones, sin grupos, sin exposición.',
  },
  {
    question: '¿En qué moneda pago?',
    answer: 'La plataforma adapta automáticamente el monto a tu moneda local.',
  },
  {
    question: '¿Qué pasa si no me sirve?',
    answer: '7 días de garantía completa. Escríbenos y te devolvemos el dinero sin preguntas.',
  },
]

export const closingLines = [
  'Sin más noches analizando lo que dijo y lo que hizo',
  'Sin más intentos de separación que terminan en regreso',
  'Sin más culpa que te hace dudar de ti misma',
  'Sin más miedo que paraliza cada decisión',
  'Sin más sensación de que perdiste quién eras',
]

export const SUPPORT_EMAIL = 'soportepuertosereno@gmail.com'

export const CHECKOUT_URL = 'https://puerto-sereno.impultienda.ar/checkout'
